import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'ein',
    standalone: false
})
export class EinPipe implements PipeTransform {
    transform(str : string="") {
        if (str.length > 2) {
            str = str.substring(0, 2) + "-" + str.substring(2, str.length);
        }

        return str;
    }
}